import { ApiKeyUpdate } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdateShareKeyListsQuery } from "@/queries/query-share-key";

export const useEditShareKey = (publicationId: string, apiKeyId: string) => {
  const updateShareKeyListsQuery = useUpdateShareKeyListsQuery(publicationId);

  return useMutationWithErrorHandler(async (apiKeyUpdate: ApiKeyUpdate) => {
    const response = await getRanaApiV1().ApiKeysApi.apiKeyUpdate({
      apiKeyId,
      apiKeyUpdate,
    });

    updateShareKeyListsQuery(response.id, response);

    return response;
  });
};
